import React from 'react';
import { motion } from 'framer-motion';
import VideoBackground from './VideoBackground';

export default function OfferPromotion() {
  return (
    <section className="relative py-32 bg-olive overflow-hidden">
      <VideoBackground 
        src="https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0516(1).mov" 
        poster="https://images.unsplash.com/photo-1519167758481-83f550bb49b3?q=80&w=2098&auto=format&fit=crop"
        overlayOpacity="bg-olive/80" 
      />
      
      <div className="relative z-20 max-w-4xl mx-auto px-6 text-center text-ivory">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <span className="text-gold-light uppercase tracking-[0.3em] text-xs mb-6 block">The Promotion</span>
          <h2 className="text-4xl md:text-5xl mb-8 font-serif">A Limited Summer Opportunity</h2>
          <p className="font-sans font-light text-lg leading-relaxed text-ivory/80 max-w-2xl mx-auto mb-16">
            For couples considering a July or August wedding, Padua is offering a special seasonal promotion on select dates. This is a limited opportunity to experience the full Padua estate wedding experience with added seasonal value.
          </p>
          
          <div className="relative max-w-lg mx-auto bg-ivory/5 backdrop-blur-md p-10 md:p-16 border border-gold/30">
            <h4 className="text-2xl text-gold-light mb-10 font-serif">Select Availability</h4>
            <ul className="space-y-6 font-sans font-light tracking-wide text-ivory/90">
              <li className="flex items-center justify-center gap-4">
                <span className="w-1 h-1 bg-gold rounded-full"></span>
                Select July & August dates available
              </li>
              <li className="flex items-center justify-center gap-4">
                <span className="w-1 h-1 bg-gold rounded-full"></span>
                Private tours now booking
              </li>
              <li className="flex items-center justify-center gap-4">
                <span className="w-1 h-1 bg-gold rounded-full"></span>
                Limited seasonal promotion
              </li>
              <li className="flex items-center justify-center gap-4">
                <span className="w-1 h-1 bg-gold rounded-full"></span>
                Inquire for available dates and details
              </li>
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
}